// import React, { useState, useRef, useEffect } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { toast } from "react-toastify";
// import JoditEditor from "jodit-react";
// import { API_BASE_URL } from "../config";

// const PLACEHOLDER_OPTIONS = [
//   { label: "Lead Name", value: "{{LEAD_NAME}}" },
//   { label: "Trademark Name", value: "{{TRADEMARK_NAME}}" },
//   { label: "Company Name", value: "{{COMPANY_NAME}}" },
//   { label: "Case ID", value: "{{CASE_ID}}" },
//   { label: "Registration Number", value: "{{REGISTRATION_NUMBER}}" },
//   { label: "Trademark Class", value: "{{TRADEMARK_CLASS}}" },
//   { label: "Filing Date", value: "{{FILING_DATE}}" },
//   { label: "Examination Date", value: "{{EXAMINATION_DATE}}" },
//   { label: "Journal Date", value: "{{JOURNAL_DATE}}" },
//   { label: "Registration Date", value: "{{REGISTRATION_DATE}}" },
//   { label: "Final Status", value: "{{FINAL_STATUS}}" },
//   { label: "Case Closed Date", value: "{{CASE_CLOSED_DATE}}" },
//   { label: "Plan Name", value: "{{PLAN_NAME}}" },
//   { label: "Plan Price", value: "{{PLAN_PRICE}}" },
//   { label: "Applicant Name", value: "{{APPLICANT_NAME}}" },
//   { label: "Attorney Name", value: "{{ATTORNEY_NAME}}" },
//   { label: "Number of Attorneys", value: "{{NUMBER_OF_ATTORNEYS}}" },
//   { label: "Total Follow-ups", value: "{{TOTAL_FOLLOWUPS}}" },
//   { label: "Service Fee", value: "{{SERVICE_FEE}}" },
//   { label: "Government Fee", value: "{{GOVT_FEE}}" },
//   { label: "GST Amount", value: "{{GST_AMOUNT}}" },
//   { label: "Total Paid", value: "{{TOTAL_PAID}}" },
//   { label: "Payment Status", value: "{{PAYMENT_STATUS}}" },
//   { label: "Renewal Due Date", value: "{{RENEWAL_DUE_DATE}}" },
//   { label: "Dashboard Link", value: "{{DASHBOARD_LINK}}" },
//   { label: "Sender Name", value: "{{SENDER_NAME}}" },
//   { label: "Sender Designation", value: "{{SENDER_DESIGNATION}}" },
//   { label: "Company Email", value: "{{COMPANY_EMAIL}}" },
//   { label: "Company Phone", value: "{{COMPANY_PHONE}}" },
//   { label: "Company Address", value: "{{COMPANY_ADDRESS}}" },
// ];

// // Allowed file types for attachments
// const ALLOWED_FILE_TYPES = [
//   "application/pdf",
//   "application/msword",
//   "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//   "application/vnd.ms-excel",
//   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   "image/jpeg",
//   "image/png",
//   "image/gif",
//   "text/plain",
// ];
// const MAX_FILE_SIZE_MB = 5;
// const MAX_ATTACHMENTS = 5;

// const getFileIcon = (type) => {
//   if (type.includes("pdf")) return "fas fa-file-pdf";
//   if (type.includes("word") || type.includes("document")) return "fas fa-file-word";
//   if (type.includes("excel") || type.includes("sheet")) return "fas fa-file-excel";
//   if (type.includes("image")) return "fas fa-file-image";
//   return "fas fa-file-alt";
// };

// const getFileIconColor = (type) => {
//   if (type.includes("pdf")) return "#ef4444";
//   if (type.includes("word") || type.includes("document")) return "#3b82f6";
//   if (type.includes("excel") || type.includes("sheet")) return "#22c55e";
//   if (type.includes("image")) return "#f59e0b";
//   return "#64748b";
// };

// const formatFileSize = (bytes) => {
//   if (bytes < 1024) return `${bytes} B`;
//   if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
//   return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
// };

// // Defined outside the component so the object reference never changes between renders.
// // jodit-react v5 destroys and recreates the editor whenever config reference changes,
// // so keeping this stable prevents the editor from resetting on every state update.
// const EDITOR_CONFIG = {
//   readonly: false,
//   height: 400,
//   toolbarAdaptive: false,
//   toolbarSticky: false,
//   buttons: [
//     "bold", "italic", "underline", "|",
//     "ul", "ol", "|",
//     "fontsize", "brush", "|",
//     "align", "|",
//     "image", "link", "table", "|",
//     "undo", "redo", "|",
//     "fullsize",
//   ],
//   uploader: { insertImageAsBase64URI: true },
//   removeButtons: ["about", "source", "strikethrough", "eraser", "hr", "font", "paragraph"],
//   showCharsCounter: false,
//   showWordsCounter: false,
//   showXPathInStatusbar: false,
//   placeholder: "Write your email content here. Click any smart tag on the right to insert it.",
//   askBeforePasteHTML: false,
//   askBeforePasteFromWord: false,
//   defaultActionOnPaste: "insert_clear_html",
//   processPasteHTML: true,
//   processPasteFromWord: true,
//   cleanHTML: {
//     fillEmptyParagraph: false,
//     replaceNBSP: true,
//   },
// };

// const CreateEmailTemplate = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const editorRef = useRef(null);
//   const fileInputRef = useRef(null);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [showPreview, setShowPreview] = useState(false);
//   const [placeholderSearch, setPlaceholderSearch] = useState("");

//   // Track which field is currently active so placeholder goes to the right place
//   // "subject" | "body" (default body)
//   const activeFieldRef = useRef("body");
//   const subjectCursorRef = useRef({ start: 0, end: 0 });
//   const templateNameCursorRef = useRef({ start: 0, end: 0 });
//   const [isDragging, setIsDragging] = useState(false);

//   // Service list fetched from API
//   const [serviceList, setServiceList] = useState([]);

//   const [formData, setFormData] = useState({
//     service_name: "",
//     template_type: [], // array: can contain "marketing", "service"
//     template_name: "",
//     subject: "",
//     body: "",
//     status: "active",
//   });

//   // attachments: array of { file: File, name: string, size: number, type: string, base64: string }
//   const [attachments, setAttachments] = useState([]);
//   // existingAttachments: attachments already saved on server (edit mode)
//   const [existingAttachments, setExistingAttachments] = useState([]);

//   const [errors, setErrors] = useState({});

//   useEffect(() => {
//     fetchServices();
//     if (id) fetchTemplate();
//   }, [id]);

//   const fetchServices = async () => {
//     try {
//       const token = localStorage.getItem("cms_token");
//       const res = await axios.get(`${API_BASE_URL}/service-names`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: { is_active: 1 },
//       });
//       if (res.data?.status && Array.isArray(res.data.data)) {
//         setServiceList(res.data.data);
//       }
//     } catch (err) {
//       console.error("Failed to fetch services", err);
//     }
//   };

//   const fetchTemplate = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("cms_token");
//       const res = await axios.get(`${API_BASE_URL}/get-email-template-details/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (res.data?.success && res.data.data) {
//         const t = res.data.data;
//         setFormData({
//           service_name: t.service_name || "",
//           template_type: t.template_type || [],
//           template_name: t.template_name || "",
//           subject: t.subject || "",
//           body: t.body || "",
//           status: t.status || "active",
//         });
//         // If API returns existing attachments as array of { name, url, size, type }
//         if (t.attachments && Array.isArray(t.attachments)) {
//           setExistingAttachments(t.attachments);
//         }
//       }
//     } catch (err) {
//       toast.error("Failed to load template");
//       navigate("/cms/templates");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const handleTemplateTypeChange = (typeValue) => {
//     setFormData((prev) => {
//       const current = prev.template_type || [];
//       const updated = current.includes(typeValue)
//         ? current.filter((t) => t !== typeValue)
//         : [...current, typeValue];
//       return { ...prev, template_type: updated };
//     });
//     if (errors.template_type) setErrors((prev) => ({ ...prev, template_type: "" }));
//   };

//   const handleEditorChange = (content) => {
//     setFormData((prev) => ({ ...prev, body: content }));
//     if (errors.body) setErrors((prev) => ({ ...prev, body: "" }));
//   };

//   const insertPlaceholder = (placeholder) => {
//     if (activeFieldRef.current === "template_name") {
//       const { start, end } = templateNameCursorRef.current;
//       const text = formData.template_name;
//       const newText = text.substring(0, start) + placeholder + text.substring(end);
//       setFormData((prev) => ({ ...prev, template_name: newText }));
//       const newPos = start + placeholder.length;
//       templateNameCursorRef.current = { start: newPos, end: newPos };
//       setTimeout(() => {
//         const el = document.querySelector('input[name="template_name"]');
//         if (el) { el.focus(); el.setSelectionRange(newPos, newPos); }
//       }, 0);
//     } else if (activeFieldRef.current === "subject") {
//       const { start, end } = subjectCursorRef.current;
//       const text = formData.subject;
//       const newText = text.substring(0, start) + placeholder + text.substring(end);
//       setFormData((prev) => ({ ...prev, subject: newText }));
//       const newPos = start + placeholder.length;
//       subjectCursorRef.current = { start: newPos, end: newPos };
//       setTimeout(() => {
//         const el = document.querySelector('input[name="subject"]');
//         if (el) { el.focus(); el.setSelectionRange(newPos, newPos); }
//       }, 0);
//     } else {
//       const editor = editorRef.current; // v5: ref.current IS the Jodit instance
//       if (editor) {
//         const sel = editor.s || editor.selection;
//         sel?.insertHTML(placeholder);
//         setTimeout(() => {
//           const content = editor.value ?? editor.getEditorValue?.() ?? "";
//           setFormData((prev) => ({ ...prev, body: content }));
//           setErrors((prev) => ({ ...prev, body: "" }));
//         }, 0);
//       } else {
//         setFormData((prev) => ({ ...prev, body: prev.body + placeholder }));
//       }
//     }
//     toast.info(`"${placeholder}" inserted`, { autoClose: 1000 });
//   };

//   // Convert file to base64
//   const fileToBase64 = (file) =>
//     new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => resolve(reader.result.split(",")[1]); // strip data:...;base64,
//       reader.onerror = reject;
//       reader.readAsDataURL(file);
//     });

//   const processFiles = async (files) => {
//     const fileArray = Array.from(files);

//     if (attachments.length + fileArray.length > MAX_ATTACHMENTS) {
//       toast.error(`Maximum ${MAX_ATTACHMENTS} attachments allowed`);
//       return;
//     }

//     for (const file of fileArray) {
//       // Type check
//       if (!ALLOWED_FILE_TYPES.includes(file.type)) {
//         toast.error(`"${file.name}" — file type not allowed`);
//         continue;
//       }
//       // Size check
//       if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
//         toast.error(`"${file.name}" exceeds ${MAX_FILE_SIZE_MB}MB limit`);
//         continue;
//       }
//       // Duplicate check
//       if (attachments.some((a) => a.name === file.name && a.size === file.size)) {
//         toast.warn(`"${file.name}" is already attached`);
//         continue;
//       }

//       try {
//         const base64 = await fileToBase64(file);
//         setAttachments((prev) => [
//           ...prev,
//           { file, name: file.name, size: file.size, type: file.type, base64 },
//         ]);
//       } catch {
//         toast.error(`Failed to read "${file.name}"`);
//       }
//     }
//   };

//   const handleFileInput = (e) => {
//     if (e.target.files?.length) processFiles(e.target.files);
//     e.target.value = ""; // reset so same file can be re-added if removed
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setIsDragging(false);
//     if (e.dataTransfer.files?.length) processFiles(e.dataTransfer.files);
//   };

//   const handleDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
//   const handleDragLeave = () => setIsDragging(false);

//   const removeAttachment = (index) => {
//     setAttachments((prev) => prev.filter((_, i) => i !== index));
//   };

//   const removeExistingAttachment = (index) => {
//     setExistingAttachments((prev) => prev.filter((_, i) => i !== index));
//   };

//   const validate = () => {
//     const errs = {};
//     if (!formData.service_name.trim()) errs.service_name = "Service name is required";
//     if (!formData.template_type || formData.template_type.length === 0) errs.template_type = "Select at least one template type";
//     if (!formData.template_name.trim()) errs.template_name = "Template name is required";
//     if (!formData.subject.trim()) errs.subject = "Subject is required";
//     if (!formData.body.trim()) errs.body = "Email body cannot be empty";
//     setErrors(errs);
//     return Object.keys(errs).length === 0;
//   };

//   const handleSubmit = async () => {
//     if (!validate()) {
//       toast.error("Please fix the errors before saving");
//       return;
//     }
//     try {
//       setSaving(true);
//       const token = localStorage.getItem("cms_token");

//       // Build payload — send attachments as base64 array
//       const payload = {
//         service_name: formData.service_name.trim(),
//         template_type: formData.template_type,
//         template_name: formData.template_name.trim(),
//         subject: formData.subject.trim(),
//         body: formData.body,
//         status: formData.status,
//         // New attachments as base64
//         attachments: attachments.map((a) => ({
//           name: a.name,
//           type: a.type,
//           size: a.size,
//           data: a.base64, // base64 string without prefix
//         })),
//         // IDs / names of existing attachments to keep (so backend knows what to delete)
//         existing_attachments: existingAttachments,
//       };

//       let res;
//       if (id) {
//         res = await axios.put(`${API_BASE_URL}/update-email-template-details/${id}`, payload, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//       } else {
//         res = await axios.post(`${API_BASE_URL}/create-email-template`, payload, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//       }

//       if (res.data?.success) {
//         toast.success(id ? "Template updated successfully" : "Template created successfully");
//         navigate("/cms/templates");
//       } else {
//         toast.error(res.data?.message || "Something went wrong");
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to save template");
//     } finally {
//       setSaving(false);
//     }
//   };


//   const filteredPlaceholders = PLACEHOLDER_OPTIONS.filter((p) =>
//     p.label.toLowerCase().includes(placeholderSearch.toLowerCase())
//   );

//   const inputStyle = {
//     borderRadius: "8px",
//     border: "1px solid #e2e8f0",
//     fontSize: "14px",
//     transition: "border-color 0.2s, box-shadow 0.2s",
//   };
//   const labelStyle = { fontSize: "13px", fontWeight: 600, color: "#374151", marginBottom: "6px" };

//   const totalAttachments = attachments.length + existingAttachments.length;

//   if (loading) {
//     return (
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid text-center py-5">
//             <div className="spinner-border text-primary" role="status"></div>
//             <p className="text-muted mt-2">Loading template...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="main-content">
//       <div className="page-content">
//         <div className="container-fluid">

//           {/* Page Title */}
//           <div className="row">
//             <div className="col-12">
//               <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                 <h4 className="mb-sm-0 font-size-18" style={{ fontWeight: 700, color: "#1f2937" }}>
//                   <i className="fas fa-envelope-open-text me-2" style={{ color: "#556ee6" }}></i>
//                   {id ? "Edit Email Template" : "Create Email Template"}
//                 </h4>
//                 <div className="page-title-right">
//                   <ol className="breadcrumb m-0">
//                     <li className="breadcrumb-item"><Link to="/cms/home">Dashboard</Link></li>
//                     <li className="breadcrumb-item"><Link to="/cms/templates">Templates</Link></li>
//                     <li className="breadcrumb-item active">{id ? "Edit" : "Create"} Email</li>
//                   </ol>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="row">
//             {/* LEFT - Form */}
//             <div className="col-lg-8">
//               <div className="card" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 16px rgba(0,0,0,0.06)", overflow: "hidden" }}>
//                 <div style={{ height: "4px", background: "linear-gradient(90deg, #556ee6, #7b68ee)" }}></div>
//                 <div className="card-body" style={{ padding: "28px" }}>
//                   <h4 className="card-title mb-4" style={{ fontWeight: 700, fontSize: "16px", color: "#1e293b" }}>
//                     Email Template Details
//                   </h4>

//                   {/* Service Name */}
//                   <div className="mb-4">
//                     <label className="form-label" style={labelStyle}>
//                       Service Name <span className="text-danger">*</span>
//                     </label>
//                     <select
//                       name="service_name"
//                       className={`form-control ${errors.service_name ? "is-invalid" : ""}`}
//                       value={formData.service_name}
//                       onChange={handleChange}
//                       style={inputStyle}
//                     >
//                       <option value="">Select Service</option>
//                       {serviceList.map((service) => (
//                         <option key={service.id} value={service.option_value}>
//                           {service.label}
//                         </option>
//                       ))}
//                     </select>
//                     {errors.service_name && <div className="invalid-feedback">{errors.service_name}</div>}
//                   </div>

//                   {/* Template Type */}
//                   <div className="mb-4">
//                     <label className="form-label" style={labelStyle}>
//                       Template Type <span className="text-danger">*</span>
//                     </label>
//                     <div className="d-flex gap-4 align-items-center" style={{ paddingTop: "4px" }}>
//                       {[
//                         { value: "marketing", label: "Marketing" },
//                         { value: "service", label: "Service" },
//                       ].map((opt) => (
//                         <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer", fontSize: "14px", color: "#374151" }}>
//                           <input
//                             type="checkbox"
//                             checked={(formData.template_type || []).includes(opt.value)}
//                             onChange={() => handleTemplateTypeChange(opt.value)}
//                             style={{ width: "16px", height: "16px", accentColor: "#556ee6", cursor: "pointer" }}
//                           />
//                           {opt.label}
//                         </label>
//                       ))}
//                     </div>
//                     {errors.template_type && (
//                       <div style={{ fontSize: "12.5px", color: "#dc3545", marginTop: "4px" }}>{errors.template_type}</div>
//                     )}
//                   </div>

//                   {/* Template Name */}
//                   <div className="mb-4">
//                     <label className="form-label" style={labelStyle}>
//                       Template Name <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       type="text" name="template_name"
//                       className={`form-control ${errors.template_name ? "is-invalid" : ""}`}
//                       placeholder="e.g., Case Closed Summary, Welcome Email..."
//                       value={formData.template_name} onChange={handleChange} style={inputStyle}
//                       onFocus={(e) => {
//                         activeFieldRef.current = "template_name";
//                         templateNameCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
//                       }}
//                       onBlur={(e) => {
//                         templateNameCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
//                       }}
//                       onKeyUp={(e) => {
//                         templateNameCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
//                       }}
//                       onSelect={(e) => {
//                         templateNameCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
//                       }}
//                       onClick={(e) => {
//                         activeFieldRef.current = "template_name";
//                         templateNameCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
//                       }}
//                     />
//                     {errors.template_name && <div className="invalid-feedback">{errors.template_name}</div>}
//                     <small className="form-text text-muted" style={{ fontSize: "12px" }}>Internal name to identify this template</small>
//                   </div>

//                   {/* Subject */}
//                   <div className="mb-4">
//                     <label className="form-label" style={labelStyle}>
//                       Email Subject <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       type="text" name="subject"
//                       className={`form-control ${errors.subject ? "is-invalid" : ""}`}
//                       placeholder='e.g., Welcome to {{COMPANY_NAME}} — Your Case #{{CASE_ID}} is Active'
//                       value={formData.subject}
//                       onChange={handleChange}
//                       style={inputStyle}
//                       onFocus={(e) => {
//                         activeFieldRef.current = "subject";
//                         subjectCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
//                       }}
//                       onBlur={(e) => {
//                         subjectCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
//                       }}
//                       onKeyUp={(e) => {
//                         subjectCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
//                       }}
//                       onSelect={(e) => {
//                         subjectCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
//                       }}
//                       onClick={(e) => {
//                         activeFieldRef.current = "subject";
//                         subjectCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
//                       }}
//                     />
//                     {errors.subject && <div className="invalid-feedback">{errors.subject}</div>}
//                     <small className="form-text text-muted" style={{ fontSize: "12px" }}>
//                       Click inside this field, then click a placeholder from the right panel to insert it here
//                     </small>
//                   </div>

//                   {/* Status */}
//                   <div className="mb-4">
//                     <label className="form-label" style={labelStyle}>Status</label>
//                     <div className="d-flex gap-3">
//                       {[
//                         { value: "active", label: "Active", color: "#22c55e", bg: "#f0fff4" },
//                         { value: "inactive", label: "Inactive", color: "#ef4444", bg: "#fff5f5" },
//                       ].map((s) => (
//                         <label key={s.value} className="d-flex align-items-center gap-2"
//                           style={{
//                             padding: "8px 18px", borderRadius: "8px",
//                             border: `2px solid ${formData.status === s.value ? s.color : "#e5e7eb"}`,
//                             backgroundColor: formData.status === s.value ? s.bg : "#fff",
//                             cursor: "pointer", transition: "all 0.2s", fontSize: "13px", fontWeight: 600,
//                             color: formData.status === s.value ? s.color : "#6b7280",
//                           }}
//                         >
//                           <input type="radio" name="status" value={s.value} checked={formData.status === s.value} onChange={handleChange} style={{ display: "none" }} />
//                           <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: formData.status === s.value ? s.color : "#d1d5db" }}></span>
//                           {s.label}
//                         </label>
//                       ))}
//                     </div>
//                   </div>

//                   {/* Body Editor */}
//                   <div className="mb-4">
//                     <label className="form-label d-flex align-items-center justify-content-between" style={labelStyle}>
//                       <span>Email Body <span className="text-danger">*</span></span>
//                       <span style={{
//                         fontSize: "11px", fontWeight: 600, padding: "3px 10px", borderRadius: "20px",
//                         backgroundColor: activeFieldRef.current === "subject" ? "#fef3c7" : "#eef2ff",
//                         color: activeFieldRef.current === "subject" ? "#d97706" : "#556ee6",
//                         border: `1px solid ${activeFieldRef.current === "subject" ? "#fde68a" : "#c7d2fe"}`,
//                       }}>
//                         <i className={`fas fa-${activeFieldRef.current === "subject" ? "heading" : "align-left"} me-1`}></i>
//                         Placeholder → {activeFieldRef.current === "subject" ? "Subject" : "Body"}
//                       </span>
//                     </label>
//                     <small className="form-text text-muted d-block mb-2" style={{ fontSize: "12px" }}>
//                       Type your email content below. Use the toolbar for formatting.
//                       Click inside Subject or Body first, then click a placeholder to insert it there.
//                     </small>
//                     {errors.body && (
//                       <div className="mb-2" style={{ fontSize: "13px", color: "#ef4444", display: "flex", alignItems: "center", gap: "6px" }}>
//                         <i className="fas fa-exclamation-circle"></i> {errors.body}
//                       </div>
//                     )}
//                     <div
//                       style={{ borderRadius: "8px", overflow: "hidden", border: errors.body ? "1px solid #ef4444" : "1px solid #e2e8f0" }}
//                       onClick={() => { activeFieldRef.current = "body"; }}
//                       onFocus={() => { activeFieldRef.current = "body"; }}
//                     >
//                       <JoditEditor ref={editorRef} value={formData.body} config={EDITOR_CONFIG} onBlur={handleEditorChange} />
//                     </div>
//                   </div>

//                   {/* ───────────── FILE ATTACHMENTS ───────────── */}
//                   <div className="mb-4">
//                     <label className="form-label d-flex align-items-center gap-2" style={labelStyle}>
//                       <i className="fas fa-paperclip" style={{ color: "#556ee6" }}></i>
//                       Attachments
//                       {totalAttachments > 0 && (
//                         <span style={{ fontSize: "11px", fontWeight: 600, padding: "2px 8px", borderRadius: "20px", backgroundColor: "#eef2ff", color: "#556ee6" }}>
//                           {totalAttachments} / {MAX_ATTACHMENTS}
//                         </span>
//                       )}
//                     </label>

//                     {/* Drop Zone */}
//                     {totalAttachments < MAX_ATTACHMENTS && (
//                       <div
//                         onClick={() => fileInputRef.current?.click()}
//                         onDrop={handleDrop}
//                         onDragOver={handleDragOver}
//                         onDragLeave={handleDragLeave}
//                         style={{
//                           border: `2px dashed ${isDragging ? "#556ee6" : "#c7d2fe"}`,
//                           borderRadius: "10px",
//                           padding: "24px",
//                           textAlign: "center",
//                           cursor: "pointer",
//                           backgroundColor: isDragging ? "#eef2ff" : "#f8faff",
//                           transition: "all 0.2s",
//                         }}
//                       >
//                         <div style={{ marginBottom: "8px" }}>
//                           <i className="fas fa-cloud-upload-alt" style={{ fontSize: "28px", color: isDragging ? "#556ee6" : "#a5b4fc" }}></i>
//                         </div>
//                         <p style={{ margin: 0, fontSize: "13px", fontWeight: 600, color: isDragging ? "#556ee6" : "#475569" }}>
//                           {isDragging ? "Drop files here" : "Click to browse or drag & drop files"}
//                         </p>
//                         <p style={{ margin: "4px 0 0", fontSize: "11.5px", color: "#94a3b8" }}>
//                           PDF, Word, Excel, Images, TXT &nbsp;·&nbsp; Max {MAX_FILE_SIZE_MB}MB each &nbsp;·&nbsp; Up to {MAX_ATTACHMENTS} files
//                         </p>
//                       </div>
//                     )}

//                     <input
//                       ref={fileInputRef}
//                       type="file"
//                       multiple
//                       accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.txt"
//                       onChange={handleFileInput}
//                       style={{ display: "none" }}
//                     />

//                     {/* Existing Attachments (edit mode) */}
//                     {existingAttachments.length > 0 && (
//                       <div className="mt-3">
//                         <p style={{ fontSize: "11px", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>
//                           Saved Attachments
//                         </p>
//                         <div className="d-flex flex-column gap-2">
//                           {existingAttachments.map((att, i) => (
//                             <div key={i} className="d-flex align-items-center gap-3"
//                               style={{ padding: "10px 14px", borderRadius: "8px", backgroundColor: "#f1f5f9", border: "1px solid #e2e8f0" }}>
//                               <i className={getFileIcon(att.type || "")} style={{ fontSize: "18px", color: getFileIconColor(att.type || ""), flexShrink: 0 }}></i>
//                               <div style={{ flex: 1, minWidth: 0 }}>
//                                 <p style={{ margin: 0, fontSize: "13px", fontWeight: 600, color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                                   {att.name}
//                                 </p>
//                                 {att.size && (
//                                   <p style={{ margin: 0, fontSize: "11px", color: "#94a3b8" }}>{formatFileSize(att.size)}</p>
//                                 )}
//                               </div>
//                               {att.url && (
//                                 <a href={att.url} target="_blank" rel="noreferrer"
//                                   style={{ color: "#556ee6", fontSize: "12px", textDecoration: "none", fontWeight: 600, flexShrink: 0 }}>
//                                   <i className="fas fa-download me-1"></i>View
//                                 </a>
//                               )}
//                               <button type="button" onClick={() => removeExistingAttachment(i)}
//                                 style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer", padding: "4px", flexShrink: 0 }}
//                                 title="Remove attachment">
//                                 <i className="fas fa-times"></i>
//                               </button>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}

//                     {/* New Attachments */}
//                     {attachments.length > 0 && (
//                       <div className="mt-3">
//                         {existingAttachments.length > 0 && (
//                           <p style={{ fontSize: "11px", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>
//                             New Attachments
//                           </p>
//                         )}
//                         <div className="d-flex flex-column gap-2">
//                           {attachments.map((att, i) => (
//                             <div key={i} className="d-flex align-items-center gap-3"
//                               style={{ padding: "10px 14px", borderRadius: "8px", backgroundColor: "#f0f9ff", border: "1px solid #bae6fd" }}>
//                               <i className={getFileIcon(att.type)} style={{ fontSize: "18px", color: getFileIconColor(att.type), flexShrink: 0 }}></i>
//                               <div style={{ flex: 1, minWidth: 0 }}>
//                                 <p style={{ margin: 0, fontSize: "13px", fontWeight: 600, color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                                   {att.name}
//                                 </p>
//                                 <p style={{ margin: 0, fontSize: "11px", color: "#94a3b8" }}>{formatFileSize(att.size)}</p>
//                               </div>
//                               <span style={{ fontSize: "10px", fontWeight: 700, padding: "2px 7px", borderRadius: "20px", backgroundColor: "#dbeafe", color: "#2563eb", flexShrink: 0 }}>
//                                 NEW
//                               </span>
//                               <button type="button" onClick={() => removeAttachment(i)}
//                                 style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer", padding: "4px", flexShrink: 0 }}
//                                 title="Remove attachment">
//                                 <i className="fas fa-times"></i>
//                               </button>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                   {/* ─────────────────────────────────────────── */}

//                   {/* Action Buttons */}
//                   <div className="d-flex justify-content-between align-items-center pt-3" style={{ borderTop: "1px solid #f1f5f9" }}>
//                     <button className="btn btn-light d-flex align-items-center gap-2" onClick={() => navigate("/cms/templates")}
//                       style={{ borderRadius: "8px", fontSize: "13px", fontWeight: 600, color: "#64748b" }}>
//                       <i className="fas fa-arrow-left" style={{ fontSize: "11px" }}></i> Back to Templates
//                     </button>
//                     <div className="d-flex gap-2">
//                       <button className="btn btn-outline-primary d-flex align-items-center gap-2" onClick={() => setShowPreview(true)}
//                         style={{ borderRadius: "8px", fontSize: "13px", fontWeight: 600 }}>
//                         <i className="fas fa-eye" style={{ fontSize: "12px" }}></i> Preview
//                       </button>
//                       <button className="btn d-flex align-items-center gap-2" onClick={handleSubmit} disabled={saving}
//                         style={{ background: "linear-gradient(135deg, #667eea, #764ba2)", color: "#fff", borderRadius: "8px", fontSize: "13px", fontWeight: 600, padding: "8px 24px", border: "none", boxShadow: "0 3px 10px rgba(102,126,234,0.3)" }}>
//                         {saving ? (
//                           <><span className="spinner-border spinner-border-sm"></span> Saving...</>
//                         ) : (
//                           <><i className="fas fa-save" style={{ fontSize: "12px" }}></i> {id ? "Update Template" : "Save Template"}</>
//                         )}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* RIGHT - Placeholders */}
//             <div className="col-lg-4">
//               <div className="card" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 16px rgba(0,0,0,0.06)", overflow: "hidden", position: "sticky", top: "80px" }}>
//                 <div style={{ height: "4px", background: "linear-gradient(90deg, #556ee6, #7b68ee)" }}></div>
//                 <div className="card-body" style={{ padding: "24px" }}>
//                   <div className="d-flex align-items-center gap-2 mb-3">
//                     <div className="d-flex align-items-center justify-content-center"
//                       style={{ width: "32px", height: "32px", borderRadius: "8px", backgroundColor: "#eef2ff" }}>
//                       <i className="fas fa-code" style={{ color: "#556ee6", fontSize: "14px" }}></i>
//                     </div>
//                     <h5 className="mb-0" style={{ fontWeight: 700, fontSize: "15px", color: "#1e293b" }}>Dynamic Placeholders</h5>
//                   </div>
//                   <p className="text-muted mb-3" style={{ fontSize: "12.5px", lineHeight: "1.6" }}>
//                     These are smart tags that auto-fill with real data when the email is sent.
//                     <br /><br />
//                     <strong style={{ color: "#374151" }}>How to use:</strong><br />
//                     1. Click inside the <em>Subject</em> or <em>Body</em> field<br />
//                     2. Click any tag below to insert it
//                   </p>
//                   <div className="position-relative mb-3">
//                     <i className="fas fa-search position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)", color: "#a0aec0", fontSize: "12px" }}></i>
//                     <input type="text" className="form-control form-control-sm" placeholder="Search placeholders..."
//                       value={placeholderSearch} onChange={(e) => setPlaceholderSearch(e.target.value)}
//                       style={{ paddingLeft: "30px", borderRadius: "7px", border: "1px solid #e2e8f0", fontSize: "12.5px" }}
//                     />
//                   </div>
//                   <div style={{ maxHeight: "400px", overflowY: "auto", paddingRight: "4px" }}>
//                     <div className="d-flex flex-wrap gap-2">
//                       {filteredPlaceholders.map((p, i) => (
//                         <button
//                           key={i}
//                           type="button"
//                           className="btn btn-sm"
//                           onMouseDown={(e) => {
//                             // Prevent button from stealing focus — cursor stays exactly where it is
//                             e.preventDefault();
//                           }}
//                           onClick={() => insertPlaceholder(p.value)}
//                           title={p.value}
//                           style={{ fontSize: "11.5px", fontWeight: 500, padding: "4px 11px", borderRadius: "6px", backgroundColor: "#f0f4ff", color: "#4338ca", border: "1px solid #c7d2fe", transition: "all 0.2s" }}
//                           onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#556ee6"; e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = "#556ee6"; }}
//                           onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#f0f4ff"; e.currentTarget.style.color = "#4338ca"; e.currentTarget.style.borderColor = "#c7d2fe"; }}
//                         >
//                           {p.label}
//                         </button>
//                       ))}
//                     </div>
//                     {filteredPlaceholders.length === 0 && (
//                       <p className="text-muted text-center mt-3 mb-0" style={{ fontSize: "13px" }}>No matching placeholders</p>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               {/* Quick Tips */}
//               <div className="card mt-3" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 16px rgba(0,0,0,0.06)", overflow: "hidden" }}>
//                 <div className="card-body" style={{ padding: "20px 24px" }}>
//                   <div className="d-flex align-items-center gap-2 mb-3">
//                     <div className="d-flex align-items-center justify-content-center"
//                       style={{ width: "32px", height: "32px", borderRadius: "8px", backgroundColor: "#fffbeb" }}>
//                       <i className="fas fa-lightbulb" style={{ color: "#f59e0b", fontSize: "14px" }}></i>
//                     </div>
//                     <h5 className="mb-0" style={{ fontWeight: 700, fontSize: "15px", color: "#1e293b" }}>Quick Tips</h5>
//                   </div>
//                   <ul className="text-muted mb-0 ps-3" style={{ fontSize: "12.5px", lineHeight: "2.1" }}>
//                     <li>Give your template a clear name like "Welcome Email"</li>
//                     <li>Click inside Subject or Body <strong>first</strong>, then click a smart tag</li>
//                     <li>Use <strong>Bold</strong> for important info like names or dates</li>
//                     <li>Always click <strong>Preview</strong> before saving</li>
//                     <li>Smart tags like Lead Name will be filled automatically on send</li>
//                     <li>Max {MAX_ATTACHMENTS} files, {MAX_FILE_SIZE_MB}MB each</li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Preview Modal */}
//           {showPreview && (
//             <>
//               <div className="modal fade show d-block" tabIndex="-1" role="dialog">
//                 <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
//                   <div className="modal-content" style={{ borderRadius: "12px", overflow: "hidden" }}>
//                     <div className="modal-header" style={{ background: "linear-gradient(135deg, #556ee6, #7b68ee)", border: "none", padding: "16px 24px" }}>
//                       <h5 className="modal-title text-white" style={{ fontWeight: 600, fontSize: "16px" }}>
//                         <i className="fas fa-eye me-2"></i>Template Preview
//                       </h5>
//                       <button type="button" className="btn-close btn-close-white" onClick={() => setShowPreview(false)}></button>
//                     </div>
//                     <div className="modal-body p-0">
//                       <div className="p-3" style={{ backgroundColor: "#f8f9fe", borderBottom: "1px solid #e9ecef" }}>
//                         <small className="text-muted d-block" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 600 }}>Subject</small>
//                         <strong style={{ fontSize: "14px", color: "#1e293b" }}>{formData.subject || "No subject"}</strong>
//                       </div>
//                       <iframe
//                         srcDoc={formData.body || "<p style='text-align:center;color:#999;padding:40px;'>No content yet</p>"}
//                         style={{ width: "100%", minHeight: "500px", border: "none" }}
//                         title="Email Preview"
//                       />
//                       {/* Attachment list in preview */}
//                       {(attachments.length > 0 || existingAttachments.length > 0) && (
//                         <div className="p-3" style={{ backgroundColor: "#f8f9fe", borderTop: "1px solid #e9ecef" }}>
//                           <small style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 700, color: "#64748b" }}>
//                             <i className="fas fa-paperclip me-1"></i>
//                             Attachments ({totalAttachments})
//                           </small>
//                           <div className="d-flex flex-wrap gap-2 mt-2">
//                             {existingAttachments.map((a, i) => (
//                               <span key={`ex-${i}`} style={{ fontSize: "12px", padding: "4px 10px", borderRadius: "6px", backgroundColor: "#e2e8f0", color: "#475569", fontWeight: 500 }}>
//                                 <i className={`${getFileIcon(a.type || "")} me-1`}></i>{a.name}
//                               </span>
//                             ))}
//                             {attachments.map((a, i) => (
//                               <span key={`new-${i}`} style={{ fontSize: "12px", padding: "4px 10px", borderRadius: "6px", backgroundColor: "#dbeafe", color: "#2563eb", fontWeight: 500 }}>
//                                 <i className={`${getFileIcon(a.type)} me-1`}></i>{a.name}
//                               </span>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                     <div className="modal-footer" style={{ borderTop: "1px solid #f1f5f9" }}>
//                       <button type="button" className="btn btn-secondary" onClick={() => setShowPreview(false)} style={{ borderRadius: "8px" }}>Close</button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-backdrop fade show"></div>
//             </>
//           )}

//         </div>
//       </div>
//     </div>
//   );
// };

// export default CreateEmailTemplate;





import React, { useState, useRef, useEffect, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Tooltip, Button, Select } from "antd";
import { ItalicOutlined, UnderlineOutlined, UnorderedListOutlined, AlignCenterOutlined, AlignRightOutlined, UndoOutlined, RedoOutlined, CodeOutlined,
} from "@ant-design/icons";
import { API_BASE_URL } from "../config";
import RichTextEditor from "./RichTextEditor";
import { authHeaders, getSessionToken } from "../cms/utils/session";
import { useEmailWidgets } from "../cms/hooks/useEmailWidgets";
import { previewWidget, hasGreetingSlot, DEFAULT_GREETING } from "../cms/email-widgets/widgetPreview";

// ── Rich Text Editor (same as BulkEmailCompose) ───────────────────────────────
// Allowed file types for attachments
const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/svg+xml",
  "text/plain",
  "text/csv",
];
const MAX_FILE_SIZE_MB = 5;
const MAX_ATTACHMENTS = 5;

const getFileIcon = (type) => {
  if (type.includes("pdf")) return "fas fa-file-pdf";
  if (type.includes("word") || type.includes("document")) return "fas fa-file-word";
  if (type.includes("excel") || type.includes("sheet") || type.includes("csv")) return "fas fa-file-excel";
  if (type.includes("image") || type.includes("svg")) return "fas fa-file-image";
  return "fas fa-file-alt";
};

const getFileIconColor = (type) => {
  if (type.includes("pdf")) return "#ef4444";
  if (type.includes("word") || type.includes("document")) return "#3b82f6";
  if (type.includes("excel") || type.includes("sheet") || type.includes("csv")) return "#22c55e";
  if (type.includes("image") || type.includes("svg")) return "#f59e0b";
  return "#64748b";
};

const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const CreateEmailTemplate = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const bodyEditorRef = useRef(null);
  const fileInputRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [placeholderSearch, setPlaceholderSearch] = useState("");

  const activeFieldRef = useRef("body");
  const subjectCursorRef = useRef({ start: 0, end: 0 });
  const templateNameCursorRef = useRef({ start: 0, end: 0 });
  const [isDragging, setIsDragging] = useState(false);

  // Placeholders grouped by category from /get-available-placeholders
  const [groupedPlaceholders, setGroupedPlaceholders] = useState({});

  // Service list fetched from API
  const [serviceList, setServiceList] = useState([]);

  const [formData, setFormData] = useState({
    service_id: "",
    template_type: "4", // 3 = Marketing (Promotional), 4 = Service (Transactional)
    context_type: "",
    template_name: "",
    subject: "",
    body: "",
    status: "active",
    widget_id: null,   // optional company design (email widget); null = this template's own HTML
    widget_greeting: null, // the widget's {{greeting}} for this template; null = "Hi {{customer_name}},"
  });

  // Email widgets (2026-10-27): the active company designs a template may use — plus the one
  // this template already has, even if it was switched off since (shown as such, kept on save).
  const { data: allWidgets = [] } = useEmailWidgets();
  const widgets = allWidgets.filter((w) => Number(w.status) === 1 || w.id === formData.widget_id);
  const chosenWidget = widgets.find((w) => w.id === formData.widget_id) || null;
  // Set when an edit loads a template that has a design — so clearing it is sent as "".
  const loadedWidgetRef = useRef(null);

  // attachments: array of { file: File, name: string, size: number, type: string }
  const [attachments, setAttachments] = useState([]);
  // existingAttachments: attachments already saved on server (edit mode)
  // Each item: { name, url, size, type }
  const [existingAttachments, setExistingAttachments] = useState([]);
  // Track which existing attachments (S3 URLs) to remove on update
  const [removedAttachmentUrls, setRemovedAttachmentUrls] = useState([]);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchServices();
    if (id) fetchTemplate();
  }, [id]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/get-available-placeholders`, {
      headers: { ...authHeaders() },
    }).then((res) => {
      if (res.data?.status && res.data.data) setGroupedPlaceholders(res.data.data);
    }).catch(() => {});
  }, []);

  const fetchServices = async () => {
    try {
      const token = getSessionToken();
      const res = await axios.get(`${API_BASE_URL}/service-names`, {
        headers: { ...authHeaders() },
        params: { is_active: 1 },
      });
      if (res.data?.status && Array.isArray(res.data.data)) {
        setServiceList(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch services", err);
    }
  };

  const fetchTemplate = async () => {
    try {
      setLoading(true);
      const token = getSessionToken();
      const res = await axios.get(`${API_BASE_URL}/get-email-template-details/${id}`, {
        headers: { ...authHeaders() },
      });
      if (res.data?.status && res.data.data) {
        const t = res.data.data;
        setFormData({
          service_id: t.service_id ? String(t.service_id) : "",
          /* Stored as 3 / 4; older rows may still carry the strings. Anything
             unrecognised falls back to Service, the safe default. */
          template_type: (() => {
            const raw = String(t.template_type ?? "").trim().toLowerCase();
            if (raw === "3" || raw === "marketing" || raw === "promotional") return "3";
            if (raw === "4" || raw === "service" || raw === "transactional") return "4";
            return "4";
          })(),
          context_type: t.context_type || "",
          template_name: t.template_name || "",
          subject: t.subject || "",
          body: t.body || "",
          status: t.status || "active",
          widget_id: t.widget_id ?? null,
          widget_greeting: t.widget_greeting ?? null,
        });
        loadedWidgetRef.current = t.widget_id ?? null;
        if (t.attachments) {
          try {
            const parsed = typeof t.attachments === "string" ? JSON.parse(t.attachments) : t.attachments;
            if (Array.isArray(parsed)) setExistingAttachments(parsed);
          } catch { /* ignore parse error */ }
        }
      }
    } catch (err) {
      toast.error("Failed to load template");
      navigate("/cms/templates");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleEditorChange = (content) => {
    setFormData((prev) => ({ ...prev, body: content }));
    if (errors.body) setErrors((prev) => ({ ...prev, body: "" }));
  };

  /* A logo / image placeholder resolves to a URL. Dropped into the body as bare
     text it renders as a visible link in the sent mail — which is what happened
     with {{company_logo}}. So in the BODY those go in wrapped in an <img>; in
     Subject / Template Name (plain text) the bare tag stays. */
  const IMAGE_PLACEHOLDER = /(logo|image|img|photo|avatar|banner|icon)/i;
  const asImageTag = (tag) =>
    `<img src="${tag}" alt="" style="max-width:180px;height:auto;display:block;" />`;

  const insertPlaceholder = (placeholder) => {
    if (activeFieldRef.current === "template_name") {
      const { start, end } = templateNameCursorRef.current;
      const text = formData.template_name;
      const newText = text.substring(0, start) + placeholder + text.substring(end);
      setFormData((prev) => ({ ...prev, template_name: newText }));
      const newPos = start + placeholder.length;
      templateNameCursorRef.current = { start: newPos, end: newPos };
      setTimeout(() => {
        const el = document.querySelector('input[name="template_name"]');
        if (el) { el.focus(); el.setSelectionRange(newPos, newPos); }
      }, 0);
    } else if (activeFieldRef.current === "subject") {
      const { start, end } = subjectCursorRef.current;
      const text = formData.subject;
      const newText = text.substring(0, start) + placeholder + text.substring(end);
      setFormData((prev) => ({ ...prev, subject: newText }));
      const newPos = start + placeholder.length;
      subjectCursorRef.current = { start: newPos, end: newPos };
      setTimeout(() => {
        const el = document.querySelector('input[name="subject"]');
        if (el) { el.focus(); el.setSelectionRange(newPos, newPos); }
      }, 0);
    } else {
      const el = bodyEditorRef.current;
      if (el) {
        const isImage = IMAGE_PLACEHOLDER.test(placeholder);
        const snippet = isImage ? asImageTag(placeholder) : placeholder;
        el.focus();
        // insertHTML for the image tag; insertText keeps a plain tag literal.
        document.execCommand(isImage ? "insertHTML" : "insertText", false, snippet);
        setFormData((prev) => ({ ...prev, body: el.innerHTML }));
        setErrors((prev) => ({ ...prev, body: "" }));
      } else {
        const isImage = IMAGE_PLACEHOLDER.test(placeholder);
        setFormData((prev) => ({
          ...prev,
          body: prev.body + (isImage ? asImageTag(placeholder) : placeholder),
        }));
      }
    }
    toast.info(
      IMAGE_PLACEHOLDER.test(placeholder) &&
        activeFieldRef.current !== "template_name" &&
        activeFieldRef.current !== "subject"
        ? `"${placeholder}" inserted as an image`
        : `"${placeholder}" inserted`,
      { autoClose: 1000 },
    );
  };

  const processFiles = async (files) => {
    const fileArray = Array.from(files);

    if (attachments.length + existingAttachments.length + fileArray.length > MAX_ATTACHMENTS) {
      toast.error(`Maximum ${MAX_ATTACHMENTS} attachments allowed`);
      return;
    }

    for (const file of fileArray) {
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        toast.error(`"${file.name}" — file type not allowed`);
        continue;
      }
      if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        toast.error(`"${file.name}" exceeds ${MAX_FILE_SIZE_MB}MB limit`);
        continue;
      }
      if (attachments.some((a) => a.name === file.name && a.size === file.size)) {
        toast.warn(`"${file.name}" is already attached`);
        continue;
      }

      setAttachments((prev) => [
        ...prev,
        { file, name: file.name, size: file.size, type: file.type },
      ]);
    }
  };

  const handleFileInput = (e) => {
    if (e.target.files?.length) processFiles(e.target.files);
    e.target.value = "";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files?.length) processFiles(e.dataTransfer.files);
  };

  const handleDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
  const handleDragLeave = () => setIsDragging(false);

  const removeAttachment = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const removeExistingAttachment = (index) => {
    const removed = existingAttachments[index];
    if (removed?.url) {
      setRemovedAttachmentUrls((prev) => [...prev, removed.url]);
    }
    setExistingAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  // Extract used placeholder keys from subject + body
  const extractPlaceholders = () => {
    const combined = (formData.subject || "") + " " + (formData.body || "");
    const matches = combined.match(/\{\{[A-Z_]+\}\}/g) || [];
    // Convert {{LEAD_NAME}} -> lead_name, deduplicate
    const keys = [...new Set(matches.map((m) => m.replace(/\{|\}/g, "").toLowerCase()))];
    return keys.join(", ");
  };

  const validate = () => {
    const errs = {};
    if (!formData.template_type) errs.template_type = "Select a template type";
    if (!formData.template_name.trim()) errs.template_name = "Template name is required";
    if (!formData.subject.trim()) errs.subject = "Subject is required";
    if (!formData.body.trim()) errs.body = "Email body cannot be empty";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      toast.error("Please fix the errors before saving");
      return;
    }
    try {
      setSaving(true);
      const token = getSessionToken();

      // Build FormData payload
      const fd = new FormData();
      fd.append("template_name", formData.template_name.trim());
      // Only sent when the template really belongs to one service.
      if (formData.service_id) fd.append("service_id", formData.service_id);
      // 3 = Promotional (Marketing), 4 = Transactional (Service). Absent → 4.
      fd.append("template_type", formData.template_type || "4");
      if (formData.context_type) fd.append("context_type", formData.context_type);
      fd.append("subject", formData.subject.trim());
      fd.append("body", formData.body);
      fd.append("status", formData.status);
      // Company design: sent when chosen; "" when an edit clears one the template had.
      if (formData.widget_id) fd.append("widget_id", String(formData.widget_id));
      else if (loadedWidgetRef.current) fd.append("widget_id", "");
      // The widget's greeting — sent when the chosen widget has a {{greeting}} slot.
      if (chosenWidget && hasGreetingSlot(chosenWidget.html)) fd.append("widget_greeting", (formData.widget_greeting ?? DEFAULT_GREETING).trim());

      // Placeholders - comma separated string of used placeholder keys
      const placeholders = extractPlaceholders();
      if (placeholders) {
        fd.append("placeholders", placeholders);
      }

      // New file attachments
      attachments.forEach((a) => {
        fd.append("attachments[]", a.file);
      });

      let res;
      if (id) {
        // Update — also send remove_attachments[] (S3 URLs to remove)
        removedAttachmentUrls.forEach((url) => {
          fd.append("remove_attachments[]", url);
        });
        fd.append("updated_by", localStorage.getItem("trade_user_id") || "");

        res = await axios.post(`${API_BASE_URL}/update-email-template-details/${id}`, fd, {
          headers: {
            ...authHeaders(),
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        fd.append("created_by", localStorage.getItem("trade_user_id") || "");

        res = await axios.post(`${API_BASE_URL}/create-email-template`, fd, {
          headers: {
            ...authHeaders(),
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (res.data?.status || res.data?.success) {
        toast.success(id ? "Template updated successfully" : "Template created successfully");
        navigate("/cms/templates");
      } else {
        toast.error(res.data?.message || "Something went wrong");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to save template");
    } finally {
      setSaving(false);
    }
  };

  const filteredGroups = Object.entries(groupedPlaceholders).reduce((acc, [key, group]) => {
    const groupContext = group.context || "global";
    // If context_type selected: show only matching context + global; hide the other context
    if (formData.context_type && groupContext !== "global" && groupContext !== formData.context_type) return acc;
    const q = placeholderSearch.toLowerCase().trim();
    const matched = Object.entries(group.placeholders || {}).filter(
      ([pKey, pData]) => !q || pKey.includes(q) || (pData.description || "").toLowerCase().includes(q)
    );
    if (matched.length > 0) acc[key] = { label: group.label, context: groupContext, placeholders: Object.fromEntries(matched) };
    return acc;
  }, {});

  const inputStyle = {
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    fontSize: "14px",
    transition: "border-color 0.2s, box-shadow 0.2s",
  };
  const labelStyle = { fontSize: "13px", fontWeight: 600, color: "#374151", marginBottom: "6px" };

  const totalAttachments = attachments.length + existingAttachments.length;

  if (loading) {
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
            <p className="text-muted mt-2">Loading template...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">

          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18" style={{ fontWeight: 700, color: "#1f2937" }}>
                  <i className="fas fa-envelope-open-text me-2" style={{ color: "#556ee6" }}></i>
                  {id ? "Edit Email Template" : "Create Email Template"}
                </h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item"><Link to="/cms/home">Dashboard</Link></li>
                    <li className="breadcrumb-item"><Link to="/cms/templates">Templates</Link></li>
                    <li className="breadcrumb-item active">{id ? "Edit" : "Create"} Email</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* LEFT - Form */}
            <div className="col-lg-8">
              <div className="card" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 16px rgba(0,0,0,0.06)", overflow: "hidden" }}>
                <div style={{ height: "4px", background: "linear-gradient(90deg, #556ee6, #7b68ee)" }}></div>
                <div className="card-body" style={{ padding: "28px" }}>
                  <h4 className="card-title mb-4" style={{ fontWeight: 700, fontSize: "16px", color: "#1e293b" }}>
                    Email Template Details
                  </h4>

                  {/* Service Name (sends service_id) */}
                  <div className="mb-4">
                    <label className="form-label" style={labelStyle}>
                      Service Name{" "}
                      <span style={{ color: "#9ca3af", fontWeight: 400, fontSize: "12px" }}>
                        (optional)
                      </span>
                    </label>
                    <select
                      name="service_id"
                      className="form-control"
                      value={formData.service_id}
                      onChange={handleChange}
                      style={inputStyle}
                    >
                      <option value="">No specific service</option>
                      {serviceList.map((service) => (
                        <option key={service.id} value={service.id}>
                          {service.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Template Type — the value IS what the backend stores:
                      3 = Promotional (Marketing), 4 = Transactional (Service).
                      Service/Transactional mail (orders, subscriptions, OTP) may
                      always go out; Marketing needs consent / unsubscribe, which
                      is why the two are kept apart. */}
                  <div className="mb-4">
                    <label className="form-label" style={labelStyle}>
                      Template Type <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-4 align-items-center" style={{ paddingTop: "4px" }}>
                      {[
                        { value: "3", label: "Marketing" },
                        { value: "4", label: "Service" },
                      ].map((opt) => (
                        <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer", fontSize: "14px", color: "#374151" }}>
                          <input
                            type="radio"
                            name="template_type"
                            value={opt.value}
                            checked={formData.template_type === opt.value}
                            onChange={handleChange}
                            style={{ width: "16px", height: "16px", accentColor: "#556ee6", cursor: "pointer" }}
                          />
                          {opt.label}
                        </label>
                      ))}
                    </div>
                    {errors.template_type && (
                      <div style={{ fontSize: "12.5px", color: "#dc3545", marginTop: "4px" }}>{errors.template_type}</div>
                    )}
                  </div>

                  {/* Context Type */}
                  <div className="mb-4">
                    <label className="form-label" style={labelStyle}>
                      Template For
                    </label>
                    <select
                      name="context_type"
                      value={formData.context_type}
                      onChange={handleChange}
                      className="form-control"
                      style={inputStyle}
                    >
                      <option value="">— Who is this template for? —</option>
                      <option value="customer">Customer</option>
                      <option value="lead">Lead</option>
                    </select>
                  </div>

                  {/* Company design (email widget) — optional */}
                  <div className="mb-4">
                    <label className="form-label" style={labelStyle} htmlFor="template-widget">
                      Email widget
                    </label>
                    <Select
                      id="template-widget"
                      aria-label="Email widget"
                      value={formData.widget_id ?? undefined}
                      onChange={(v) => setFormData((prev) => ({ ...prev, widget_id: v ?? null }))}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      placeholder="None — use this template's own HTML"
                      style={{ width: "100%" }}
                      size="large"
                      options={widgets.map((w) => ({ value: w.id, label: Number(w.status) === 1 ? w.name : `${w.name} (switched off)` }))}
                    />
                    <small className="form-text text-muted" style={{ fontSize: "12px" }}>
                      {chosenWidget
                        ? "Write only the message below — the widget adds the company header, greeting, sign-off and footer."
                        : "Optional. Pick one to write just the message and send it in an email widget."}
                    </small>
                  </div>

                  {/* The widget's greeting for this template (2026-10-28) — senders may still change it */}
                  {chosenWidget && hasGreetingSlot(chosenWidget.html) && (
                    <div className="mb-4">
                      <label className="form-label" style={labelStyle} htmlFor="template-widget-greeting">Greeting</label>
                      <input id="template-widget-greeting" type="text" className="form-control" style={inputStyle} maxLength={150}
                        value={formData.widget_greeting ?? DEFAULT_GREETING}
                        onChange={(e) => setFormData((prev) => ({ ...prev, widget_greeting: e.target.value }))}
                        placeholder={DEFAULT_GREETING} />
                      <small className="form-text text-muted" style={{ fontSize: "12px" }}>
                        The opening line. {"{{customer_name}}"} fills in per recipient — or write e.g. "Dear Sir/Madam,".
                      </small>
                    </div>
                  )}

                  {/* Template Name */}
                  <div className="mb-4">
                    <label className="form-label" style={labelStyle}>
                      Template Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text" name="template_name"
                      className={`form-control ${errors.template_name ? "is-invalid" : ""}`}
                      placeholder="e.g., Case Closed Summary, Welcome Email..."
                      value={formData.template_name} onChange={handleChange} style={inputStyle}
                      onFocus={(e) => {
                        activeFieldRef.current = "template_name";
                        templateNameCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
                      }}
                      onBlur={(e) => {
                        templateNameCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
                      }}
                      onKeyUp={(e) => {
                        templateNameCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
                      }}
                      onSelect={(e) => {
                        templateNameCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
                      }}
                      onClick={(e) => {
                        activeFieldRef.current = "template_name";
                        templateNameCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
                      }}
                    />
                    {errors.template_name && <div className="invalid-feedback">{errors.template_name}</div>}
                    <small className="form-text text-muted" style={{ fontSize: "12px" }}>Internal name to identify this template</small>
                  </div>

                  {/* Subject */}
                  <div className="mb-4">
                    <label className="form-label" style={labelStyle}>
                      Email Subject <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text" name="subject"
                      className={`form-control ${errors.subject ? "is-invalid" : ""}`}
                      placeholder='e.g., Welcome to {{COMPANY_NAME}} — Your Case #{{CASE_ID}} is Active'
                      value={formData.subject}
                      onChange={handleChange}
                      style={inputStyle}
                      onFocus={(e) => {
                        activeFieldRef.current = "subject";
                        subjectCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
                      }}
                      onBlur={(e) => {
                        subjectCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
                      }}
                      onKeyUp={(e) => {
                        subjectCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
                      }}
                      onSelect={(e) => {
                        subjectCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
                      }}
                      onClick={(e) => {
                        activeFieldRef.current = "subject";
                        subjectCursorRef.current = { start: e.target.selectionStart, end: e.target.selectionEnd };
                      }}
                    />
                    {errors.subject && <div className="invalid-feedback">{errors.subject}</div>}
                    <small className="form-text text-muted" style={{ fontSize: "12px" }}>
                      Click inside this field, then click a placeholder from the right panel to insert it here
                    </small>
                  </div>

                  {/* Status */}
                  <div className="mb-4">
                    <label className="form-label" style={labelStyle}>Status</label>
                    <div className="d-flex gap-3">
                      {[
                        { value: "active", label: "Active", color: "#22c55e", bg: "#f0fff4" },
                        { value: "inactive", label: "Inactive", color: "#ef4444", bg: "#fff5f5" },
                      ].map((s) => (
                        <label key={s.value} className="d-flex align-items-center gap-2"
                          style={{
                            padding: "8px 18px", borderRadius: "8px",
                            border: `2px solid ${formData.status === s.value ? s.color : "#e5e7eb"}`,
                            backgroundColor: formData.status === s.value ? s.bg : "#fff",
                            cursor: "pointer", transition: "all 0.2s", fontSize: "13px", fontWeight: 600,
                            color: formData.status === s.value ? s.color : "#6b7280",
                          }}
                        >
                          <input type="radio" name="status" value={s.value} checked={formData.status === s.value} onChange={handleChange} style={{ display: "none" }} />
                          <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: formData.status === s.value ? s.color : "#d1d5db" }}></span>
                          {s.label}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Body Editor */}
                  <div className="mb-4">
                    <label className="form-label d-flex align-items-center justify-content-between" style={labelStyle}>
                      <span>Email Body <span className="text-danger">*</span></span>
                      <span style={{
                        fontSize: "11px", fontWeight: 600, padding: "3px 10px", borderRadius: "20px",
                        backgroundColor: activeFieldRef.current === "subject" ? "#fef3c7" : "#eef2ff",
                        color: activeFieldRef.current === "subject" ? "#d97706" : "#556ee6",
                        border: `1px solid ${activeFieldRef.current === "subject" ? "#fde68a" : "#c7d2fe"}`,
                      }}>
                        Placeholder → {activeFieldRef.current === "subject" ? "Subject" : "Body"}
                      </span>
                    </label>
                    {errors.body && (
                      <div className="mb-2" style={{ fontSize: "13px", color: "#ef4444", display: "flex", alignItems: "center", gap: "6px" }}>
                        <i className="fas fa-exclamation-circle"></i> {errors.body}
                      </div>
                    )}
                    <div
                      onClick={() => { activeFieldRef.current = "body"; }}
                      onFocus={() => { activeFieldRef.current = "body"; }}
                      style={{ outline: errors.body ? "1.5px solid #ef4444" : "none", borderRadius: 10 }}
                    >
                      <RichTextEditor
                        value={formData.body}
                        onChange={(html) => { setFormData((prev) => ({ ...prev, body: html })); if (errors.body) setErrors((prev) => ({ ...prev, body: "" })); }}
                        placeholder="Write your email content here. Click a placeholder on the right to insert it."
                        editorNodeRef={bodyEditorRef}
                      />
                    </div>
                  </div>

                  {/* ───────────── FILE ATTACHMENTS ───────────── */}
                  <div className="mb-4">
                    <label className="form-label d-flex align-items-center gap-2" style={labelStyle}>
                      <i className="fas fa-paperclip" style={{ color: "#556ee6" }}></i>
                      Attachments
                      {totalAttachments > 0 && (
                        <span style={{ fontSize: "11px", fontWeight: 600, padding: "2px 8px", borderRadius: "20px", backgroundColor: "#eef2ff", color: "#556ee6" }}>
                          {totalAttachments} / {MAX_ATTACHMENTS}
                        </span>
                      )}
                    </label>

                    {/* Drop Zone */}
                    {totalAttachments < MAX_ATTACHMENTS && (
                      <div
                        onClick={() => fileInputRef.current?.click()}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        style={{
                          border: `2px dashed ${isDragging ? "#556ee6" : "#c7d2fe"}`,
                          borderRadius: "10px",
                          padding: "24px",
                          textAlign: "center",
                          cursor: "pointer",
                          backgroundColor: isDragging ? "#eef2ff" : "#f8faff",
                          transition: "all 0.2s",
                        }}
                      >
                        <div style={{ marginBottom: "8px" }}>
                          <i className="fas fa-cloud-upload-alt" style={{ fontSize: "28px", color: isDragging ? "#556ee6" : "#a5b4fc" }}></i>
                        </div>
                        <p style={{ margin: 0, fontSize: "13px", fontWeight: 600, color: isDragging ? "#556ee6" : "#475569" }}>
                          {isDragging ? "Drop files here" : "Click to browse or drag & drop files"}
                        </p>
                        <p style={{ margin: "4px 0 0", fontSize: "11.5px", color: "#94a3b8" }}>
                          PDF, Word, Excel, Images, SVG, CSV, TXT &nbsp;·&nbsp; Max {MAX_FILE_SIZE_MB}MB each &nbsp;·&nbsp; Up to {MAX_ATTACHMENTS} files
                        </p>
                      </div>
                    )}

                    <input
                      ref={fileInputRef}
                      type="file"
                      multiple
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.svg,.csv,.txt"
                      onChange={handleFileInput}
                      style={{ display: "none" }}
                    />

                    {/* Existing Attachments (edit mode) */}
                    {existingAttachments.length > 0 && (
                      <div className="mt-3">
                        <p style={{ fontSize: "11px", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>
                          Saved Attachments
                        </p>
                        <div className="d-flex flex-column gap-2">
                          {existingAttachments.map((att, i) => (
                            <div key={i} className="d-flex align-items-center gap-3"
                              style={{ padding: "10px 14px", borderRadius: "8px", backgroundColor: "#f1f5f9", border: "1px solid #e2e8f0" }}>
                              <i className={getFileIcon(att.type || "")} style={{ fontSize: "18px", color: getFileIconColor(att.type || ""), flexShrink: 0 }}></i>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <p style={{ margin: 0, fontSize: "13px", fontWeight: 600, color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {att.name}
                                </p>
                                {att.size && (
                                  <p style={{ margin: 0, fontSize: "11px", color: "#94a3b8" }}>{formatFileSize(att.size)}</p>
                                )}
                              </div>
                              {att.url && (
                                <a href={att.url} target="_blank" rel="noreferrer"
                                  style={{ color: "#556ee6", fontSize: "12px", textDecoration: "none", fontWeight: 600, flexShrink: 0 }}>
                                  <i className="fas fa-download me-1"></i>View
                                </a>
                              )}
                              <button type="button" onClick={() => removeExistingAttachment(i)}
                                style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer", padding: "4px", flexShrink: 0 }}
                                title="Remove attachment">
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* New Attachments */}
                    {attachments.length > 0 && (
                      <div className="mt-3">
                        {existingAttachments.length > 0 && (
                          <p style={{ fontSize: "11px", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>
                            New Attachments
                          </p>
                        )}
                        <div className="d-flex flex-column gap-2">
                          {attachments.map((att, i) => (
                            <div key={i} className="d-flex align-items-center gap-3"
                              style={{ padding: "10px 14px", borderRadius: "8px", backgroundColor: "#f0f9ff", border: "1px solid #bae6fd" }}>
                              <i className={getFileIcon(att.type)} style={{ fontSize: "18px", color: getFileIconColor(att.type), flexShrink: 0 }}></i>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <p style={{ margin: 0, fontSize: "13px", fontWeight: 600, color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {att.name}
                                </p>
                                <p style={{ margin: 0, fontSize: "11px", color: "#94a3b8" }}>{formatFileSize(att.size)}</p>
                              </div>
                              <span style={{ fontSize: "10px", fontWeight: 700, padding: "2px 7px", borderRadius: "20px", backgroundColor: "#dbeafe", color: "#2563eb", flexShrink: 0 }}>
                                NEW
                              </span>
                              <button type="button" onClick={() => removeAttachment(i)}
                                style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer", padding: "4px", flexShrink: 0 }}
                                title="Remove attachment">
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  {/* ─────────────────────────────────────────── */}

                  {/* Action Buttons */}
                  <div className="d-flex justify-content-between align-items-center pt-3" style={{ borderTop: "1px solid #f1f5f9" }}>
                    <button className="btn btn-light d-flex align-items-center gap-2" onClick={() => navigate("/cms/templates")}
                      style={{ borderRadius: "8px", fontSize: "13px", fontWeight: 600, color: "#64748b" }}>
                      <i className="fas fa-arrow-left" style={{ fontSize: "11px" }}></i> Back to Templates
                    </button>
                    <div className="d-flex gap-2">
                      <button className="btn btn-outline-primary d-flex align-items-center gap-2" onClick={() => setShowPreview(true)}
                        style={{ borderRadius: "8px", fontSize: "13px", fontWeight: 600 }}>
                        <i className="fas fa-eye" style={{ fontSize: "12px" }}></i> Preview
                      </button>
                      <button className="btn d-flex align-items-center gap-2" onClick={handleSubmit} disabled={saving}
                        style={{ background: "linear-gradient(135deg, #667eea, #764ba2)", color: "#fff", borderRadius: "8px", fontSize: "13px", fontWeight: 600, padding: "8px 24px", border: "none", boxShadow: "0 3px 10px rgba(102,126,234,0.3)" }}>
                        {saving ? (
                          <><span className="spinner-border spinner-border-sm"></span> Saving...</>
                        ) : (
                          <><i className="fas fa-save" style={{ fontSize: "12px" }}></i> {id ? "Update Template" : "Save Template"}</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT - Placeholders */}
            <div className="col-lg-4">
              <div className="card" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 16px rgba(0,0,0,0.06)", overflow: "hidden", position: "sticky", top: "80px" }}>
                <div style={{ height: "4px", background: "linear-gradient(90deg, #556ee6, #7b68ee)" }}></div>
                <div className="card-body" style={{ padding: "24px" }}>
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="d-flex align-items-center justify-content-center"
                      style={{ width: "32px", height: "32px", borderRadius: "8px", backgroundColor: "#eef2ff" }}>
                      <i className="fas fa-code" style={{ color: "#556ee6", fontSize: "14px" }}></i>
                    </div>
                    <h5 className="mb-0" style={{ fontWeight: 700, fontSize: "15px", color: "#1e293b" }}>Dynamic Placeholders</h5>
                  </div>
                  <p className="text-muted mb-3" style={{ fontSize: "12.5px", lineHeight: "1.6" }}>
                    These are smart tags that auto-fill with real data when the email is sent.
                    <br /><br />
                    <strong style={{ color: "#374151" }}>How to use:</strong><br />
                    1. Click inside the <em>Subject</em> or <em>Body</em> field<br />
                    2. Click any tag below to insert it
                  </p>
                  <div className="position-relative mb-3">
                    <i className="fas fa-search position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)", color: "#a0aec0", fontSize: "12px" }}></i>
                    <input type="text" className="form-control form-control-sm" placeholder="Search placeholders..."
                      value={placeholderSearch} onChange={(e) => setPlaceholderSearch(e.target.value)}
                      style={{ paddingLeft: "30px", borderRadius: "7px", border: "1px solid #e2e8f0", fontSize: "12.5px" }}
                    />
                  </div>
                  {!formData.context_type && (
                    <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "8px", padding: "8px 12px", marginBottom: "12px", fontSize: "12px", color: "#92400e", display: "flex", alignItems: "center", gap: "6px" }}>
                      <i className="fas fa-info-circle" style={{ flexShrink: 0 }}></i>
                      Select <strong>"Template For"</strong> above to filter relevant placeholders.
                    </div>
                  )}
                  <div style={{ maxHeight: "400px", overflowY: "auto", paddingRight: "4px" }}>
                    {Object.keys(filteredGroups).length === 0 ? (
                      <p className="text-muted text-center mt-3 mb-0" style={{ fontSize: "13px" }}>
                        {Object.keys(groupedPlaceholders).length === 0 ? "Loading placeholders..." : "No matching placeholders"}
                      </p>
                    ) : (
                      Object.entries(filteredGroups).map(([groupKey, group]) => (
                        <div key={groupKey} style={{ marginBottom: "14px" }}>
                          <div style={{ fontSize: "10px", fontWeight: 700, color: "#556ee6", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: "8px", paddingBottom: "5px", borderBottom: "1px dashed #e0e7ff", display: "flex", alignItems: "center", gap: "6px" }}>
                            <i className="fas fa-layer-group" style={{ fontSize: "9px" }}></i>
                            {group.label}
                            <span style={{ marginLeft: "auto", fontSize: "9px", fontWeight: 600, padding: "1px 7px", borderRadius: "10px", textTransform: "capitalize", letterSpacing: 0, background: group.context === "lead" ? "#fff1f2" : group.context === "customer" ? "#f0fdf4" : "#f1f5f9", color: group.context === "lead" ? "#e11d48" : group.context === "customer" ? "#16a34a" : "#475569", border: `1px solid ${group.context === "lead" ? "#fecdd3" : group.context === "customer" ? "#bbf7d0" : "#cbd5e1"}` }}>
                              {group.context === "global" ? "Global" : group.context}
                            </span>
                          </div>
                          <div className="d-flex flex-wrap gap-2">
                            {Object.entries(group.placeholders || {}).map(([pKey, pData]) => (
                              <button
                                key={pKey}
                                type="button"
                                className="btn btn-sm"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => insertPlaceholder(`{{${pKey}}}`)}
                                title={`{{${pKey}}} — ${pData.description}`}
                                style={{ fontSize: "11.5px", fontWeight: 500, padding: "4px 11px", borderRadius: "6px", backgroundColor: "#f0f4ff", color: "#4338ca", border: "1px solid #c7d2fe", transition: "all 0.2s" }}
                                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#556ee6"; e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = "#556ee6"; }}
                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#f0f4ff"; e.currentTarget.style.color = "#4338ca"; e.currentTarget.style.borderColor = "#c7d2fe"; }}
                              >
                                {pData.description}
                              </button>
                            ))}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>

              {/* Quick Tips */}
              <div className="card mt-3" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 16px rgba(0,0,0,0.06)", overflow: "hidden" }}>
                <div className="card-body" style={{ padding: "20px 24px" }}>
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="d-flex align-items-center justify-content-center"
                      style={{ width: "32px", height: "32px", borderRadius: "8px", backgroundColor: "#fffbeb" }}>
                      <i className="fas fa-lightbulb" style={{ color: "#f59e0b", fontSize: "14px" }}></i>
                    </div>
                    <h5 className="mb-0" style={{ fontWeight: 700, fontSize: "15px", color: "#1e293b" }}>Quick Tips</h5>
                  </div>
                  <ul className="text-muted mb-0 ps-3" style={{ fontSize: "12.5px", lineHeight: "2.1" }}>
                    <li>Give your template a clear name like "Welcome Email"</li>
                    <li>Click inside Subject or Body <strong>first</strong>, then click a smart tag</li>
                    <li>Use <strong>Bold</strong> for important info like names or dates</li>
                    <li>Always click <strong>Preview</strong> before saving</li>
                    <li>Smart tags like Lead Name will be filled automatically on send</li>
                    <li>Max {MAX_ATTACHMENTS} files, {MAX_FILE_SIZE_MB}MB each</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Preview Modal */}
          {showPreview && (
            <>
              <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                  <div className="modal-content" style={{ borderRadius: "12px", overflow: "hidden" }}>
                    <div className="modal-header" style={{ background: "linear-gradient(135deg, #556ee6, #7b68ee)", border: "none", padding: "16px 24px" }}>
                      <h5 className="modal-title text-white" style={{ fontWeight: 600, fontSize: "16px" }}>
                        <i className="fas fa-eye me-2"></i>Template Preview
                      </h5>
                      <button type="button" className="btn-close btn-close-white" onClick={() => setShowPreview(false)}></button>
                    </div>
                    <div className="modal-body p-0">
                      <div className="p-3" style={{ backgroundColor: "#f8f9fe", borderBottom: "1px solid #e9ecef" }}>
                        <small className="text-muted d-block" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 600 }}>Subject</small>
                        <strong style={{ fontSize: "14px", color: "#1e293b" }}>{formData.subject || "No subject"}</strong>
                      </div>
                      <iframe
                        srcDoc={chosenWidget
                          ? previewWidget(chosenWidget.html, formData.body, formData.subject, formData.widget_greeting ?? undefined)
                          : (formData.body || "<p style='text-align:center;color:#999;padding:40px;'>No content yet</p>")}
                        style={{ width: "100%", minHeight: "500px", border: "none" }}
                        title="Email Preview"
                      />
                      {/* Attachment list in preview */}
                      {(attachments.length > 0 || existingAttachments.length > 0) && (
                        <div className="p-3" style={{ backgroundColor: "#f8f9fe", borderTop: "1px solid #e9ecef" }}>
                          <small style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 700, color: "#64748b" }}>
                            <i className="fas fa-paperclip me-1"></i>
                            Attachments ({totalAttachments})
                          </small>
                          <div className="d-flex flex-wrap gap-2 mt-2">
                            {existingAttachments.map((a, i) => (
                              <span key={`ex-${i}`} style={{ fontSize: "12px", padding: "4px 10px", borderRadius: "6px", backgroundColor: "#e2e8f0", color: "#475569", fontWeight: 500 }}>
                                <i className={`${getFileIcon(a.type || "")} me-1`}></i>{a.name}
                              </span>
                            ))}
                            {attachments.map((a, i) => (
                              <span key={`new-${i}`} style={{ fontSize: "12px", padding: "4px 10px", borderRadius: "6px", backgroundColor: "#dbeafe", color: "#2563eb", fontWeight: 500 }}>
                                <i className={`${getFileIcon(a.type)} me-1`}></i>{a.name}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="modal-footer" style={{ borderTop: "1px solid #f1f5f9" }}>
                      <button type="button" className="btn btn-secondary" onClick={() => setShowPreview(false)} style={{ borderRadius: "8px" }}>Close</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-backdrop fade show"></div>
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default CreateEmailTemplate;